import { useTranslation } from 'react-i18next';
import { CardPocket } from '@/common/components/CardPocket/CardPocket';
import { Icon } from '@/common/components/Icons/Icon';
import { ROUTES } from '@/common/constants/routes';
import { useGetEWADetails } from '@/common/integrations/menhir/employee/salary/salary.hooks';
import { useRouter } from 'expo-router';
import { getWidgetContent } from './PTEWACardPocket.utils';

export function PTEWACardPocket() {
  const { t } = useTranslation();
  const { details, isInitialLoading } = useGetEWADetails();
  const router = useRouter();
  const { primaryAmount, primaryLabel } = getWidgetContent(details);

  const isBlocked = details?.status === 'blocked' || details?.isBlockedDay;

  return (
    <CardPocket
      title={t('wallet.ewa_widget.title')}
      icon={
        isBlocked ? <Icon icon="lock" /> : <Icon icon="money-bill-trend-up" />
      }
      iconBadgeColor={isBlocked ? 'neutral30' : 'accentSecondary20'}
      values={[
        {
          label: primaryLabel,
          value: primaryAmount,
          loading: isInitialLoading,
        },
      ]}
      onPress={() => router.navigate(ROUTES.EWA)}
    />
  );
}
